import { Box, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import Grid from '@mui/material/Grid2'
import { Asset } from "@shared/ui";
import { useTranslation } from "react-i18next";
import { I18N_NAMESPACE } from "./i18n";

interface Props {
    isDone: boolean
    message: string
    isFocused: boolean
    onClick: () => void
}
export function StepProgress(props: Props){
    const {
        isDone, 
        
        message,
        onClick,
        
        isFocused,
    } = props
    let stepColor = 'rgba(90, 103, 125, 0.1)'
    if(isDone) stepColor = '#4CAF50'
    if(isDone && !isFocused) stepColor = '#B4DCB6'

    if(isFocused && !isDone) stepColor = '#5A677D'
    if(isFocused && isDone) stepColor = '#4CAF50'
      
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const { t } = useTranslation(I18N_NAMESPACE)

    return (
        <Box sx={{mt: '5px', p: '10px', minHeight: '30px', cursor: 'pointer', borderRadius: '10px', ":hover": {backgroundColor: 'rgba(138, 138, 138, 0.1)'}}} onClick={onClick}>
            <Box
                sx={{
                    backgroundColor: stepColor,
                    width: '100%',
                    height: '4px',
                    borderRadius: '2px'
                }}
            />
            <Grid container sx={{ mt: '5px'}}>
                <Grid size={isMobile ? 12 : 9}>
                    <Stack direction={'row'}>
                        {
                            isDone 
                                ? <Asset namespace="icons" filename="done.svg"/> 
                                : isFocused
                                    ? <Asset namespace="icons" filename="edit.svg"/> 
                                    : <Asset namespace="icons" filename="plus.svg"/>
                        }
                    
                        <Typography sx={{
                            lineHeight: '20px',
                            color: 'rgb(90, 103, 125)',
                            fontFamily: 'Rubik',
                            fontSize: 14,
                            ml: '3px'
                        }}>
                            {message}
                        </Typography>
                    </Stack>
                </Grid>
                {isFocused && !isMobile && (
                    <Grid size={3}>
                        <Box sx={{backgroundColor: "#407DFF", color: 'white', p: '1px 2px', borderRadius: '5px', textAlign: 'center'}}>
                            <Typography variant="caption" sx={{fontSize: '11px', fontFamily: 'Rubik'}} >{t('youHere')}</Typography>
                        </Box>
                    </Grid>
                )}
            </Grid>
        </Box>
    )
}